import { useEffect, useRef, useState } from 'react';
import { Member } from '~/types';

const useMentionList = (members: Member[]) => {
  const mentionListRef = useRef<HTMLUListElement>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isOpenRef = useRef(isOpen);
  const selectedIndexRef = useRef(0);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    selectedIndexRef.current = selectedIndex;
    if (mentionListRef.current) {
      const memberItemHeight = 44;
      if (selectedIndex === 0) {
        mentionListRef.current.scrollTop = 0;
      } else if (
        mentionListRef.current.clientHeight <=
        selectedIndex * memberItemHeight
      ) {
        mentionListRef.current.scrollTop = selectedIndex * memberItemHeight;
      }
    }
  }, [selectedIndex, members.length]);

  useEffect(() => {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  return {
    mentionListRef,
    isOpen,
    setIsOpen,
    isOpenRef,
    selectedIndex,
    setSelectedIndex,
    selectedIndexRef,
  };
};

export default useMentionList;
